// src/store/index.js
import { configureStore } from "@reduxjs/toolkit";

// Slice'ları içe aktarıyoruz (alfabetik sıra ile)
import authReducer from "./slices/authSlice";
import languageReducer from "./slices/languageSlice";
import settingsReducer from "./slices/settingsSlice";
import themeReducer from "./slices/themeSlice";
import uiReducer from "./slices/uiSlice";

// Service API'leri içe aktarıyoruz (alfabetik sıra ile)
import { announcementApi } from "../services/announcementApi";
import { brandApi } from "../services/brandApi";
import { campaignApi } from "../services/campaignApi";
import {userApi} from "../services/userApi";
import { surveyApi } from "../services/surveyApi";
import { tenantApi } from "../services/tenantApi";
import { drawApi } from "../services/drawApi";
import { ticketsApi } from "../services/ticketsService";
import { feedbackApi } from "../services/feedbackService";
import { paymentApi } from "../services/paymentService";
import { giftApi } from "../services/giftService";
import { videosApi } from "../services/videosApi";
import { dashboardService } from "../services/dashboardService";
import { reportsApi } from "../services/reportsApi";
// Import aiSurveyApi
import {
  aiSurveyReducer,
  aiSurveyMiddleware,
  aiSurveyReducerPath,
} from "../services/aiSurveyApi";

// Import AuthService to inject store
import AuthService from '../services/authService';

export const store = configureStore({
  reducer: {
    // API Reducers
    [announcementApi.reducerPath]: announcementApi.reducer,
    [brandApi.reducerPath]: brandApi.reducer,
    [campaignApi.reducerPath]: campaignApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [dashboardService.reducerPath]: dashboardService.reducer,
    [surveyApi.reducerPath]: surveyApi.reducer,
    [tenantApi.reducerPath]: tenantApi.reducer,
    [drawApi.reducerPath]: drawApi.reducer,
    [ticketsApi.reducerPath]: ticketsApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [giftApi.reducerPath]: giftApi.reducer,
    [videosApi.reducerPath]: videosApi.reducer,
    [aiSurveyReducerPath]: aiSurveyReducer, // ✅ Added missing aiSurvey reducer
    [reportsApi.reducerPath]: reportsApi.reducer,
    // Local Reducers
    auth: authReducer,
    language: languageReducer,
    settings: settingsReducer,
    theme: themeReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(announcementApi.middleware)
      .concat(brandApi.middleware)
      .concat(campaignApi.middleware)
      .concat(userApi.middleware)
      .concat(dashboardService.middleware)
      .concat(surveyApi.middleware)
      .concat(tenantApi.middleware)
      .concat(drawApi.middleware)
      .concat(ticketsApi.middleware)
      .concat(feedbackApi.middleware)
      .concat(aiSurveyMiddleware)
      .concat(paymentApi.middleware)
      .concat(giftApi.middleware)
      .concat(videosApi.middleware)
      .concat(reportsApi.middleware),
});

// Inject store into AuthService for RTK Query usage
AuthService.setStore(store);

export default store;
